import { ReactImageMagnify } from 'src/ReactImageMagnify';

// eslint-disable-next-line import/no-default-export
export default ReactImageMagnify;

export type {
    Interactions,
    MagnifiedImagePosition,
    InputType,
    Point,
    MagnifiedImageProps,
    ImageProps,
    LensProps,
    HintProps,
    PortalProps,
    MagnifyContainerProps,
} from 'src/types';
